import Vue from 'vue';
import babyloan from './babyloan/babyloan.vue';
import babyloanKo from './babyloan-ko/babyloan-ko.vue';
import babyloanCalculator from './babyloan-calculator/babyloan-calculator.vue';
import store from '../common/js/vuex/store';
import babyloanVuex from './babyloan/babyloan-vuex';
if (!store.hasModule(['babyloan'])) {
	store.registerModule('babyloan', babyloanVuex);
}
Vue.component('babyloan', babyloan);
Vue.component('babyloan-ko', babyloanKo);
Vue.component('babyloan-calculator', babyloanCalculator);
